import requestNonAuthenticated from "./utils/requestNonAuthenticated";

export const externalSurvey = {
    getExternalSurvey: (surveyId) => {
        return requestNonAuthenticated('GET', `es-pms/${surveyId}`);
    },
    getSurveyForm: (surveyId) => {
        return requestNonAuthenticated("GET", `es-pms/answers_form/${surveyId}`);
    },
    submitSurveyAnswer: (surveyId, data) => {
        return requestNonAuthenticated("POST", `es-pms/answers_store/${surveyId}`, data);
    },
    getDemographicInfo: () => {
        return requestNonAuthenticated('GET', `survey-demographic-informations`);
    },
}